// extracted by mini-css-extract-plugin
export default {"container":"detail_container__H6gcT","table":"detail_table__eAr-c"};